import Color from 'color';
import styled from 'styled-components';
import { redColor } from '../components/LogTable.styled';

const danger = redColor;
const dangerSoft = Color(danger).lighten(0.42).toString();
const success = '#2e7d4f';
const successSoft = Color(success).lighten(0.55).toString();
const ink = '#212137';
const inkMuted = '#6b6b7b';
const surface = '#f6f6f8';
const border = Color('lightgrey').lighten(0.05).toString();

export const Container = styled.div`
  width: 90vw;
  max-width: 400px;
  padding: 22px 22px 18px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(33, 33, 55, 0.14);
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  position: relative;
  color: ${ink};
  pointer-events: auto;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding-right: 28px;
  margin-bottom: 18px;
`;

export const DangerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${dangerSoft};
  color: ${danger};

  & > svg {
    font-size: 22px;
  }
`;

export const SuccessIcon = styled(DangerIcon)`
  background: ${successSoft};
  color: ${success};
`;

export const PreviewIcon = styled(DangerIcon)`
  background: ${Color(inkMuted).alpha(0.12).toString()};
  color: ${Color(inkMuted).darken(0.2).toString()};
`;

export const MainLabel = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: ${ink};
  line-height: 1.25;
`;

export const SubLabel = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  color: ${inkMuted};
  line-height: 1.4;
`;

export const EntryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 14px;
  border-radius: 8px;
  background: ${surface};
  border: 1px solid ${border};
  margin-bottom: 14px;
`;

export const EntryCardLabel = styled.div`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${inkMuted};
`;

export const EntryAmount = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${ink};
  line-height: 1.2;
  letter-spacing: -0.01em;
`;

export const EntryMeta = styled.div`
  margin-top: 4px;
  font-size: 12.5px;
  font-weight: 400;
  color: ${inkMuted};
  line-height: 1.35;
`;

export const EntryId = styled.span`
  font-weight: 600;
  color: ${Color(inkMuted).darken(0.15).toString()};
`;

export const PreviewMessage = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid ${border};
  font-size: 12.5px;
  font-weight: 400;
  color: ${ink};
  line-height: 1.45;
  word-break: break-word;
`;

export const Warning = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 11px 12px;
  border-radius: 8px;
  background: ${Color(danger).alpha(0.06).toString()};
  border: 1px solid ${Color(danger).alpha(0.16).toString()};
  color: ${Color(danger).darken(0.15).toString()};
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 18px;

  & > svg {
    flex-shrink: 0;
    margin-top: 1px;
    font-size: 18px;
  }
`;

export const Info = styled(Warning)`
  background: ${Color(success).alpha(0.07).toString()};
  border: 1px solid ${Color(success).alpha(0.18).toString()};
  color: ${Color(success).darken(0.12).toString()};
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;
`;

export const SecondaryBtn = styled.button`
  appearance: none;
  border: 1px solid ${border};
  background: white;
  color: ${ink};
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;

  &:hover {
    background: ${surface};
    border-color: ${Color(border).darken(0.08).toString()};
  }
`;

export const DangerBtn = styled.button`
  appearance: none;
  border: none;
  background: ${danger};
  color: white;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 120ms ease;

  &:hover {
    background: ${Color(danger).darken(0.08).toString()};
  }
`;

export const RestoreBtn = styled(DangerBtn)`
  background: ${success};

  &:hover {
    background: ${Color(success).lighten(0.08).toString()};
  }
`;

export const WideContainer = styled(Container)`
  max-width: 460px;
`;

export const PurpleBtn = styled.button`
  appearance: none;
  border: none;
  background: #7914cc;
  color: white;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 16px;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  margin-bottom: 12px;
  transition: background 120ms ease;

  &:hover {
    background: #6a12b5;
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

export const LostList = styled.ul`
  list-style: none;
  margin: 0 0 14px;
  padding: 10px 12px;
  border-radius: 8px;
  background: ${surface};
  border: 1px solid ${border};
`;

export const LostItem = styled.li`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
  line-height: 1.4;
  padding: 4px 0;
  color: ${ink};

  & + & {
    border-top: 1px solid ${border};
  }
`;

export const LostStanding = styled.span`
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${inkMuted};
`;

export const SummaryBox = styled.div`
  margin: 0 0 14px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid ${border};
  background: white;
`;

export const SummaryLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${inkMuted};
  margin-bottom: 6px;
`;

export const SummaryText = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: ${ink};
  white-space: pre-wrap;
  word-break: break-word;
`;

export const MeaningList = styled.ul`
  list-style: none;
  margin: 0 0 14px;
  padding: 12px 14px;
  border-radius: 8px;
  background: ${surface};
  border: 1px solid ${border};
`;

export const MeaningItem = styled.li`
  position: relative;
  padding: 5px 0 5px 14px;
  font-size: 13px;
  line-height: 1.45;
  color: ${ink};

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 12px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: ${Color(inkMuted).alpha(0.7).toString()};
  }
`;
